import { ref } from '@nuxtjs/composition-api';
import { defineStore } from 'pinia';

import { propertiesApiConfig } from '@/config/api/properties';
import { useClientApi } from '@/plugins/api/lk';
import { decorateApiActions } from '@/shared/lib';

export interface AddFavoriteRequest {
  area: number;
  floor: number;
  number: number;
  profitbaseId: number;
  article: string;
  citySlug: string;
  projectSlug: string;
}

export const usePropertyStore = defineStore('property', () => {
  const currentProfitBaseId = ref<number>();

  function setCurrentProfitBaseId (id: number): void {
    currentProfitBaseId.value = id;
  }

  function resetProfitBaseId (): void {
    currentProfitBaseId.value = undefined;
  }

  async function getPropertyFavorite (profitbaseId: number): Promise<boolean | undefined> {
    const url = propertiesApiConfig.likeById(profitbaseId);
    const {
      data,
    } = await useClientApi().get<boolean>(url);

    return data;
  }

  async function addPropertyFavorite (payload: AddFavoriteRequest): Promise<void> {
    const url = propertiesApiConfig.like;
    await useClientApi().post<boolean>(url, {
      ...payload,
    });
  }

  async function deletePropertyFavorite (profitbaseId: number): Promise<void> {
    const url = propertiesApiConfig.likeById(profitbaseId);
    await useClientApi().delete<boolean>(url);
  }

  return {
    currentProfitBaseId,
    setCurrentProfitBaseId,
    resetProfitBaseId,
    ...decorateApiActions({
      deletePropertyFavorite,
      getPropertyFavorite,
      addPropertyFavorite,
    }, 'store/property.ts'),
  };
});
